import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";

export default function ReturnExchangePage() {
  return (
    <main className="min-h-screen my-14 px-4 flex justify-center">
      <div className="w-full max-w-4xl">
        
        {/* Header */}
        <PageHeader>RETURN & EXCHANGE</PageHeader>

        {/* Card */}
                <section className="bg-white shadow-xl border border-pink-100 rounded-2xl p-6 md:p-10 mt-6">

          {/* Intro */}
          <p className="text-gray-700 leading-relaxed mb-6">
            At <span className="font-semibold text-black">Aura Girl</span>, we want your shopping experience to be smooth and joyful. 
            While we take great care to deliver high-quality products, we understand that sometimes fit or fabric preferences may differ. 
            That’s why we offer easy returns and exchanges within{" "}
            <span className="font-medium">7 days</span> of receiving your order.
            We strive to deliver the best quality products. If something isn’t right, we’re here to help.
          </p>

          <hr className="my-6 border-gray-200" />

          {/* Exchange Policy */}
          <div className="mb-8">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Exchange Policy
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
                Items must be unused, unwashed, and returned in their original packaging with all tags intact.
              </li>
              <li>
                Each order is eligible for one exchange only.
              </li>
              <li>
                Exchanges are applicable only for the products of the same value.
              </li>
              <li>
                Once exchanged the product cannot be exchanged again.
              </li>
              <li>
                All returned items go through a quality check. Products failing QC will be shipped back to the customer.
              </li>
            </ul>
          </div>

          <hr className="my-6 border-gray-200" />

          {/* Return Policy */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Return Policy
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
                We currently do not offer refunds.
              </li>
              <li>
                Only product exchange is available.
              </li>
              <li>
                Shipping charges are non-refundable.
              </li>
            </ul>
          </div>

        <hr className="my-6 border-gray-200" />

        {/* How To Apply */}
          {/* <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              How To Apply
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
               Requests are reviewed within 24–48 hours.
              </li>
               <li>
              Store Credit will be issued 2–3 working days after receiving the product(minus ₹100 reverse pickup charge).
              </li>
              <li>
              Note: Please take a photo/video while handing over the parcel to the courier as proof in case of disputes. Only hand over the specific item for which pickup is arranged.
              </li>
            </ul>
          </div>

          <hr className="my-6 border-gray-200" /> */}

            {/* Important Points */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Important Points
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
               A ₹100 reverse pickup fee will be applicable for all exchanges.
              </li>
               <li>
               If your request is rejected during Quality Check (QC), you may contact us on WhatsApp for further clarification.
              </li>
              <li>
               If your order status shows “Delivered” but you haven’t received it, 
               please inform us within 3 days (72 hours). Courier partners do not accept complaints beyond this timeframe.
              </li>
            </ul>
          </div>
          
          <hr className="my-6 border-gray-200" />

           {/* Customer Care */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Customer Care
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
               Requests are reviewed within 24-48 hours
              </li>
              <li>
               Exchanges are processed within 2-3 working days after the product is received and approved.
              </li>
              <li>
               Note: Please take a photo/video while handling over the parcel to the courier as proof in case of disputes.
               Only hand over the specific item for which pickup is arranged. 
              </li>
            </ul>
          </div>
          
          <hr className="my-6 border-gray-200" />

          {/* Color Difference */}
          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              Color Difference
            </h2>

            <ul className="space-y-3 text-gray-700 list-disc pl-5">
              <li>
               Product colours may slightly vary due to studio lighting during shoots.
              </li>
            </ul>
          </div>

          <hr className="my-6 border-gray-200" />

          <div>
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-black">
              ❤ We can’t wait to see you back at AURA GIRL!
            </h2>
          </div>

        </section>
      </div>
    </main>
  );
}

